import * as React from 'react';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

/**
 * Refresh the current component based on the distance with the date.
 * If a `null` value is passed, the refresh is skipped.
 */
export function useDateRefresh(value: Date | null): void {
    const [, refresh] = React.useReducer((c) => c + 1, 0);
    const days = value ? value.getTime() / DAY : null;
    const period = days === null ? null : days > 0 ? HOUR : MINUTE;

    React.useEffect(() => {
        if (!period) {
            return;
        }

        const intervalID = setInterval(() => {
            refresh();
        }, period);

        return () => {
            clearInterval(intervalID);
        };
    }, [period]);
}
